import { RouterProvider as ReactRouterProvider } from 'react-router/dom'

import {
  useAppAvailable,
  useInitData,
  useIsDashboardAvailable,
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useUserData,
} from '../hooks'
import { getAppRouter } from '../router'
import { isWorkerUser } from '../utils/user'

function RouterProvider() {
  const { authorized, availableSections, sections } = useInitData()
  const appAvailable = useAppAvailable()
  const isDashboardAvailable = useIsDashboardAvailable()
  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()
  const userData = useUserData()

  // The router depends on the role only: a router rebuilt per refetched user
  // inherits the mounted page's stale navigation blocker
  const role = userData?.role

  const router = getAppRouter({
    appAvailable,
    authorized,
    availableSections,
    hasDashboard: isDashboardAvailable,
    isExternalContactProfileNGAvailable,
    isProviderProfileNGAvailable,
    isUserProfileNGAvailable,
    isWorker: isWorkerUser({ role }),
    sections,
  })

  return <ReactRouterProvider router={router} />
}

export default RouterProvider
